import { render } from "./PlayerTextInput.vue?vue&type=template&id=520c1cba"
import script from "./PlayerTextInput.vue?vue&type=script&lang=js"
export * from "./PlayerTextInput.vue?vue&type=script&lang=js"

import "./PlayerTextInput.vue?vue&type=style&index=0&id=520c1cba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__